const MapIconSVG = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1514 22.3999L2.6665 26.6666V9.59992L11.1514 5.33325M11.1514 22.3999L20.8483 26.6666M11.1514 22.3999V5.33325M20.8483 26.6666L29.3332 22.3999V5.33325L20.8483 9.59992M20.8483 26.6666V9.59992M20.8483 9.59992L11.1514 5.33325"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MapIconSVG;
